import {sx} from './sx'
import {Stack} from "@mui/material";
import UserBar from "@view/sidebar/userBar/UserBar";
import {useActionContext} from "@context/actionContext/hooks/useActionContext";
import {useBuildNavigate} from "@view/navigate/hooks/useBuildNavigate";
import ItemNavigateRouter from "@view/navigate/item/ItemNavigateRouter";
import ItemNavigateLink from "@view/navigate/item/ItemNavigateLink";

const Navigate = () => {

    const {setVisibleMobileSidebar} = useActionContext()

    const navigate = useBuildNavigate()

    const list = navigate.map((navigate) => {
        if (navigate?.router) {
            return (
                <ItemNavigateRouter
                    key={navigate.path}
                    setVisibleMobileSidebar={setVisibleMobileSidebar}
                    navigate={navigate}
                />
            )
        }
        return (
            <ItemNavigateLink
                key={navigate.path}
                navigate={navigate}
            />
        )
    })

    return (
        <Stack
            sx={sx.root}
        >
            <UserBar/>

            <Stack sx={sx.list}>
                {list}
            </Stack>
        </Stack>
    )
}

export default Navigate;
